import ViewViewModel from '@/ViewModels/ViewViewModel';

import Messenger from '@/Utility/Messenger';
import * as CoreFrameInterfaces from '#/CoreFrameInterfaces';

import Config from '@/Management/GlobalConfiguration';
import RADApplication from '@/Management/RADApplication';
import ResourceManager from '@/Management/ResourceManager';
import ComponentManager from '@/Management/ComponentManager';
import NavigationService from '@/Management/NavigationService';
import LabelViewModelT from '@/ViewModels/Controls/LabelViewModel';
import BreadCrumbViewModelT from '@/ViewModels/Controls/BreadCrumbViewModel';

/**
 * Repräsentiert das ViewModel der ViewExtension
 */
export default class ViewExtensionViewModel extends ViewViewModel {

    public showTitle: boolean;
    public key: string;
    public headerTitle: KnockoutObservable<string>;
    public registeredForMessages: boolean;
    public pageTitle: BreadCrumbViewModelT;

    protected BreadCrumbViewModel = ComponentManager.getViewModel<typeof BreadCrumbViewModelT>('BreadCrumbViewModel');
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>('LabelViewModel');

    public constructor(protected params: CoreFrameInterfaces.ViewExtensionViewModelConstructorParameter) {
        super(params);

        this.showTitle = this.paramOrDefault(params.showTitle, Config.viewExtension.ShowContextHeader);
        this.key = this.paramOrDefault(params.key, this.viewFactory.ergName);

        if (params.headerTitle) {
            this.headerTitle = this.observableOrDefault(params.headerTitle, '');
        }
        else if (params.headerErgName) {
            this.headerTitle = this.observableOrDefault(ResourceManager.getInstance().get(params.headerErgName), '');
        }
        else {
            this.headerTitle = this.observableOrDefault(ResourceManager.getInstance().get(this.viewFactory.ergName), '');
        }

        this.registeredForMessages = false;

        this.pageTitle = new this.BreadCrumbViewModel({
            parentLocator: this.locator,
            locator: 'ext-breadcrumbs',
            elements: [
                new this.LabelViewModel({
                    caption: this.headerTitle
                })
            ]
        });

        if (!params.isInherited) {
            this.init();
        }
    }

    protected disposeInternal(): void {
        this.unregisterMessages();
        this.sendExitedMessage();

        super.disposeInternal();
    }

    public init() {
        this.setTitle(this.headerTitle());
        this.registerForPrincipalChangedMessage();

        const params: CoreFrameInterfaces.IExtensionViewEnteredMessageParameters = {
            context: this,
            key: this.key,
            title: this.headerTitle,
            PDO_ID: this.params.PDO_ID
        };
        Messenger.createMessageAndSend('ExtensionViewEnteredMessage', params);
    }

    public raiseHeaderChange() {
        let msg = {} as any;
        msg.title = this.headerTitle;
        Messenger.createMessageAndSend('ChangeHeaderTitleMessage', msg);
    }

    public setTitle(title: string) {
        this.headerTitle(title);
        this.raiseHeaderChange();
    }

    /**
     * Fordert das System auf die aktuelle ExtensionView zu verlassen 
     */
    public exit() {
        this.sendExitedMessage();
        NavigationService.getInstance().navigateBack();
    }

    /**
     * Registrierung für Navigations-Message falls der Kontext mit aussstehenden Änderungen verlassen wird
     */
    public registerForPrincipalChangedMessage() {
        if (!this.registeredForMessages) {
            Messenger.registerForMessageId('PrincipalChangedMessage', (message) => {
                if (RADApplication.getInstance().currentDetailViewContext() == null) {
                    NavigationService.getInstance().refresh();
                }
            }, this);
            this.registeredForMessages = true;
        }
    }

    /**
     * Deregistriert alle Registrierungen für Messages
     */
    public unregisterMessages() {
        Messenger.unregisterForMessageId('PrincipalChangedMessage', null, this);
    }

    private sendExitedMessage() {
        Messenger.createMessageAndSend('ExtensionViewExitedMessage', {
            context: this
        });
    }
}

ComponentManager.setViewModel('ViewExtensionViewModel', ViewExtensionViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');